// @flow
import { combineReducers } from 'redux';
import salesEstimationReducer from './salesEstimationReducer';
import salesPropositionReducer from './salesPropositionReducer';

export default combineReducers({ estimation: salesEstimationReducer, proposition: salesPropositionReducer });



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/reducer/index.js